import { useEffect } from "react";

import { ReadOnlyNotice } from "@/components/ReadOnlyNotice";
import { DESTINATIONS } from "@/lib/destinations";

/**
 * The one shape every destination's placeholder takes (spec judgement call
 * 1): the destination name at `{typography.title}`, one `{typography.body}`
 * sentence, nothing else. Real domain content for any of these nine is
 * Epics 5–9's job — this story exists so the URL-restoration and
 * active-nav-state acceptance criteria are genuinely testable end to end
 * before any of that is built.
 *
 * `ReadOnlyNotice` renders inside this same content column, above the
 * title, rather than in the shell — this story has no record header yet
 * for it to sit in (that's a later screen's job); each of Epics 5–9's real
 * record headers should render it themselves once they exist.
 */
export function DestinationPlaceholder({ id }: { id: string }) {
  const destination = DESTINATIONS.find((d) => d.id === id);
  if (!destination) {
    throw new Error(`No destination is registered with id "${id}".`);
  }

  useEffect(() => {
    document.title = `${destination.label} — PropDesk`;
  }, [destination.label]);

  return (
    <div className="max-w-record-column-max">
      <ReadOnlyNotice className="mb-4" />
      <h1 className="text-title font-semibold tracking-title text-ink md:hidden">{destination.label}</h1>
      <p className="mt-4 text-body text-ink-secondary">{destination.sentence}</p>
    </div>
  );
}
